import { render, staticRenderFns } from "./BriefsListPane.vue?vue&type=template&id=63cab8d3&scoped=true"
import script from "./BriefsListPane.vue?vue&type=script&lang=js"
export * from "./BriefsListPane.vue?vue&type=script&lang=js"
import style0 from "./BriefsListPane.vue?vue&type=style&index=0&id=63cab8d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cab8d3",
  null
  
)

export default component.exports